/**
 * ZIP CODE LOOKUP - LOCAL
 * ========================
 * Reemplaza todas las llamadas a zipcodebase.com
 * 
 * REQUISITO: us-zipcodes.js debe estar cargado antes que este archivo.
 * En Shopify, agrégalo como asset en el layout/theme.liquid:
 *   <script src="{{ 'us-zipcodes.js' | asset_url }}" defer></script>
 *   <script src="{{ 'zip-lookup.js' | asset_url }}" defer></script>
 */

(function (global) {
  'use strict';

  /**
   * Busca un ZIP code en la base de datos local.
   * Reemplaza: fetch(`https://app.zipcodebase.com/api/v1/search?...`)
   *
   * @param {string} zipCode - 5 dígitos
   * @returns {{ city, state, state_code, latitude, longitude } | null}
   */
  function lookupZip(zipCode) {
    const db = global.ZIP_DB;

    if (!db) {
      console.error('❌ ZIP_DB no está cargado. Asegúrate de incluir us-zipcodes.js antes.');
      return null;
    }

    const entry = db[zipCode];
    if (!entry) return null;

    // Devuelve el mismo formato que devolvía la API de zipcodebase
    return {
      postal_code: zipCode,
      country_code: 'US',
      city: entry.city,
      state: entry.state,
      state_code: entry.sc,
      latitude: entry.lat.toString(),
      longitude: entry.lng.toString()
    };
  }

  /**
   * Reemplaza la función fetchZipCoordinates de find-store.js
   * Devuelve el mismo formato que esperaba el código original.
   *
   * @param {string} zipCode
   * @returns {{ location, displayName, zipCode, city, state, stateCode } | null}
   */
  function resolveZip(zipCode) {
    if (!zipCode || !/^\d{5}$/.test(zipCode)) return null;

    const result = lookupZip(zipCode);
    if (!result) return null;

    return {
      location: {
        lat: parseFloat(result.latitude),
        lng: parseFloat(result.longitude)
      },
      displayName: `${result.city}, ${result.state_code}`,
      zipCode: zipCode,
      city: result.city,
      state: result.state,
      stateCode: result.state_code
    };
  }

  /**
   * Valida un ZIP y devuelve datos básicos.
   * Reemplaza la validación de custom-quote-form.liquid
   *
   * @param {string} zipCode
   * @returns {{ valid, zipCode?, city?, state?, error? }}
   */
  function validateZip(zipCode) {
    if (!zipCode || !/^\d{5}$/.test(zipCode)) {
      return { valid: false, error: 'Please enter a valid 5-digit ZIP code' };
    }

    const result = lookupZip(zipCode);
    if (!result) {
      return { valid: false, error: 'Please enter a valid ZIP code' };
    }

    return {
      valid: true,
      zipCode: zipCode,
      city: result.city,
      state: result.state_code
    };
  }

  // Exponer en window para uso global (compatible con Shopify sin bundler)
  global.ZipLookup = { lookupZip, resolveZip, validateZip };

})(window);
